import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input, Modal } from 'antd';

import { promoteToBlueprint, selectors } from 'state';

type Props = {
  session_id: number;
  visible: boolean;
  hide: () => void;
};

/**
 * Save a live session's config as a new blueprint family (v1). The source
 * session is never modified — its config is snapshot-copied into a fresh
 * template. Admin-only, ungated.
 */
const PromoteBlueprintModal: React.FC<Props> = ({
  session_id,
  visible,
  hide,
}) => {
  const dispatch = useDispatch();
  const waiting = useSelector(selectors.blueprintsWaiting);
  const [form] = Form.useForm();

  return (
    <Modal
      title={`Save session ${session_id} as a blueprint`}
      open={visible}
      onCancel={hide}
      footer={null}
      width={480}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ name: '', category: '' }}
        onFinish={() => {
          const data = form.getFieldsValue() as {
            name: string;
            category?: string;
          };
          dispatch(
            promoteToBlueprint({
              session_id,
              name: data.name,
              category: data.category || undefined,
            }),
          );
          hide();
        }}
      >
        <Form.Item
          label="Blueprint name"
          name="name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <Input placeholder="Blueprint name" />
        </Form.Item>
        <Form.Item label="Category" name="category">
          <Input placeholder="Optional category" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={hide} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={waiting}>
            Save as blueprint
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PromoteBlueprintModal;
